
import { create } from "zustand";
import { devtools } from "zustand/middleware";





const storeApi = (set) => ({

    totalLotes: 0,
    activarLote: null,


    setActivarLote: (valor) => {
        set({ activarLote: valor })
    },

});





export const useLotesStore = create(
    devtools(
        storeApi
    )
)
